export default __webpack_public_path__ + "static/media/icon-down.5f041f55.svg";